<template>
    <Collapse v-if="list.length">
        <template slot="title">
            {{t('selectMember.member')}}
        </template>
        <template slot="content">
            <MemberNode 
                v-for="(item, index) in list"
                :key="index"
                :data="item"
                @handleChecked="handleChecked" />
            <Load v-if="hasMore" 
                :hasData="!!list.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="handleSearch"/>
        </template>
    </Collapse>
</template>
<script>
import Mixin from './mixin';
import { getMemberList } from '../utils';
import MemberNode from '../section/section-member-node';

export default {
    name: 'SearchMemberResult',
    mixins: [ Mixin ],
    components: {
        MemberNode
    },
    data() {
        return {}
    },
    computed: {
        deptIds() {
            const { deptList = [], orgId } = this.root
            return deptList && deptList.map((item)=>{
                return item.deptId
            }).join(',') || orgId
        }
    },
    methods: {
        handleSearch() {
            const { host, qzId, keyword, chooseDeptType, language, security, token} = this.root;
            this.loading = true;
            return getMemberList(host, qzId, {
                page: this.page,
                size: this.size,
                keyword: keyword || '',
                deptIds: this.deptIds,
                type: chooseDeptType,
                language: language,
                security: security,
                token: token,
                includeDuty: true
            }).then(res => {
                let data = res.data
                if(!Array.isArray(data)) throw new Error();
                data.forEach(item => {
                    item.checked = false
                })
                this.list = this.list.concat(data);
                this.page ++;
                this.hasMore = data.length >= this.size;
            }).catch(error => {
                this.list = [];
                this.hasMore = true;
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>
